import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAlarmReducer (state: RootState): AcAlarmsState {
  return state.acalarmsReducer
}
